import React from "react";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-navy text-beige p-6 mt-10 text-center space-y-2 shadow-inner">
      <h2 className="text-xl font-bold">{t("welcome")}</h2>
      <p className="font-semibold">{t("builtBy")}</p>
      <p className="text-sm">{t("tagline")}</p>
      <p className="italic text-coral">{t("slogan")}</p>
      <p className="text-xs text-gold mt-4">
      ⚙️ Developed by h3lpmat3 Consultancy • {new Date().getFullYear()} • v2.0.0
      </p>
    </footer>
  );
}